import React  from "react";
import { protected_api_call, tab_filter_url, patient_filter_url, sched_filter_url } from "../api/api";
import { VscLoading } from "react-icons/vsc";
import { Link } from 'react-router-dom'


class SchedTwo extends React.Component {

    state = {
        results: [],
        first_name: "",
        last_name: "",
        dob: "",
    }

    filterFormField = []

    componentDidMount = async () => {

        let response = await protected_api_call( sched_filter_url, {} ,"POST" )
        if(response.status === 200 || response.status === 201) {
            let resp = await response.json()
            console.log(resp)
            this.setState({results: resp["data"], loading: false})
        } else {
            this.setState({loading: false})
            alert("Server Error")
        }
    
      this.filterFormField = [
        {
            "name": "First Name",
            "id_name": "first_name",
            "type": "text"
        },
        {
            "name": "Last Name",
            "id_name": "last_name",
            "type": "text"
        },
        {
            "name": "DOB",
            "id_name": "dob",
            "type": "date"
        }

      ]
      this.setState({})
    }

    render() {
        console.log(this.state.userinfo)
        return (
            <>
                <div className=' w-full flex justify-between'>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2'>
                        Scheduled Before Two Weeks
                    </h1>
                </div>

                {
                    this.state.results.length == 0 ? (
                        <div className='grid mt-10 place-items-center'>
                            <h1 className='text-2xl font-bold border text-purple-800  border-purple-300 px-10 py-2 rounded-lg  bg-purple-200'>NO RESULTS FOUND</h1>
                        </div>
                    ) : (
                        <>

                            {this.state.results.map((data, key) => (
                                <div className='flex justify-between items-center bg-purple-200 p-4 rounded-lg my-3 border border-purple-300 rounded-lg'>
                                    <h1>Name: {data.FirstName + ' ' + data.LastName}</h1>
                                    <h1>Hospital: {data.Hospital}</h1>
                                    <h1>Diagnosis: {data.Diagonosis}</h1>
                                    <h1>Criticality: {data.Criticality}</h1>
                                    <h1>Insurance: {data.Insurance}</h1>
                                    {/* <h1> Village: {data.NativeVillage === "" ? "NA" : data.NativeVillage} </h1> */}
                                    <div>
                                        {/* <Link to={`/form/auth_${data.ApplicationID}`} state={{ "userinfo": data }} className='bg-green-600 mr-3 p-2 rounded-lg text-white text-center'>
                                            UPDATE
                                        </Link> */}
                                        <Link onClick={(event) => {}} target="_blank" rel="noopener noreferrer" to={`/info/${data.id}`} state={{"userinfo": data}} className='bg-purple-900 p-2 rounded-lg text-white text-center'>
                                            INFO
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </>       
                    )
                }
            </>
        )
    }
}

export default SchedTwo;